// extracted by mini-css-extract-plugin
module.exports = {"blog":"blog_blog__3k-ZQ","blogLeft":"blog_blogLeft__3L_r7","blogRight":"blog_blogRight__20eYx"};